import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.68 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-5v-6c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-2.86.68-4.5 3.24-4.5 6.32v6h-1a1 1 0 100 2h14a1 1 0 100-2h-1zm-2 0h-8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z" fill="#444" /></svg>;